import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  background: transparent;
  padding-bottom: 1rem;
  border-bottom: 1px solid #3d3d3d;
  margin-bottom: 1rem;
`;

export const Filter = styled.div``;

type ButtonProps = {
  isSelected: boolean;
};

export const Button = styled.div<ButtonProps>`
  background: transparent;
  color: var(--white);
  font-family: DM Sans;
  font-size: 1rem;
  line-height: 1rem;
  margin-right: 1.5rem;
  transition: all 0.2s ease-in-out;
  cursor: pointer;

  &:hover {
    color: var(--primary);
  }

  ${({ isSelected }) =>
    isSelected &&
    css`
      color: var(--primary);
      font-weight: 600;
      padding-bottom: 3px;
      border-bottom: 3px solid var(--primary);
    `}
`;

export const Select = styled.select`
  background: transparent;
  border: none;
  color: var(--grey-100);
  font-family: DM Sans;
  font-size: 1rem;
  line-height: 1rem;
  margin: 0;
  width: auto;

  &:focus {
    background: var(--black-100);
    border-radius: 0.3rem;
    border: none;
  }
`;
